import { AppRoutes } from '@core/AppRoutes'
import { appHistory } from '@core/Utils/routing/history'

export const navigateToSportsPath = () => {
  appHistory.push(AppRoutes.Sports)
}
